
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { BookOpen, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { goToHeroOrderForm } from '@/lib/utils';


const AuthorSection = () => {
  
  
  const bookSteps = [
    {
      step: "Step 1",
      title: "Break Into The Software Consulting Industry",
      topics: [
        "My Personal Story of How I Ended Up in Software Consulting",
        "The Best College Degree for Software Consulting",
        "The 8 MUST-HAVE Skills to Develop for Consulting",
        "How to Create the Perfect Resume to Get Hired into a Consulting Job",
        "How to Optimize Your Resume Once You Become Independent",
        "How to Ace Your Interview and Get Hired",
        "How to Become an Expert Consultant"
      ]
    },
    {
      step: "Step 2",
      title: "Double Your Software Consulting Salary",
      topics: [
        "Line Up Your First Project as an Independent Consultant Before You Leave Your Current Job",
        "Why Staying an Employee Is Riskier Than Going Independent",
        "The Huge Emerging Trend Toward Going Independent",
        "What to Do When You Can't Find Work as an Independent Consultant",
        "How to Identify Bad Contracts vs Good Contracts",
        "How Much to Charge for Your Work",
        "How to Get Repeat Business",
        "How to Create Your Company, Run Payroll, and Master Cash Flow",
        "How to Save on Taxes by Using a Specific Legal Entity Structure",
        "How to Get Health Insurance for Yourself and Your Family When You're Independent",
        "The Different Types of Business Insurance You'll Need as an Independent Consultant",
        "The Best Laptop to Buy for Consulting and How to Set It Up With the Right Software",
        "How to Privately let Recruiters Know You're Open to Contract Work",
        "The Important Difference Between Recruiting Agencies and Consulting Firms and Which One Pays You More"
      ]
    },
    {
      step: "Step 3",
      title: "Work Half the Year",
      topics: [
        "How to Master Over-Booking to Supercharge Your Life and Finances",
        "The Dangers of Over-Booking and Why It Could Break Your Business or Your Life",
        "How to Multiply Yourself Using Technology",
        "How to Hire Your Replacement",
        "Ways to Hack Your Body and Work Environment for Maximum Productivity"
      ]
    },
    {
      step: "Step 4",
      title: "Invest In Your Dreams",
      topics: [
        "How to Contribute Up to $69,000 into Your 401(k) Each Year as an Independent Consultant",
        "How to Implement the Same Strategy That Big Banks Use to Protect and Grow Their Funds that's MUCH Better Than Retirement Accounts Like a 401(k) and IRA",
        "How to Grow Your Business So You Can Get the Same Income WITHOUT Taking on Any Projects Yourself"
      ]
    }
  ];

  return (
    <section className="light-section py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-12 text-book-darkBlue">
          What's Inside The Book
        </h2>
        
        <div className="grid gap-8 md:gap-12 max-w-6xl mx-auto">
          {bookSteps.map((step, index) => (
            <Card key={index} className={`overflow-hidden border-l-4 ${index % 2 === 0 ? 'border-l-book-yellow' : 'border-l-book-blue'} shadow-lg hover:shadow-xl transition-all duration-300`}>
              <CardContent className="p-0">
                <div className="flex flex-col md:flex-row">
                  <div className={`md:w-1/4 p-6 ${index % 2 === 0 ? 'bg-book-yellow/10' : 'bg-book-blue/10'} flex items-center justify-center`}>
                    <div className="text-center">
                      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white shadow-inner mb-3">
                        <BookOpen className={`h-8 w-8 ${index % 2 === 0 ? 'text-book-yellow' : 'text-book-blue'}`} />
                      </div>
                      <h3 className="text-xl font-bold">{step.step}</h3>
                      <div className={`w-10 h-1 mx-auto mt-2 ${index % 2 === 0 ? 'bg-book-yellow' : 'bg-book-blue'}`}></div>
                    </div>
                  </div>
                  
                  <div className="md:w-3/4 p-6">
                    <h3 className="text-2xl font-bold mb-4 text-book-darkBlue">{step.title}</h3>
                    <div className="grid gap-2 md:grid-cols-2">
                      {step.topics.map((topic, topicIndex) => (
                        <div key={topicIndex} className="flex items-start">
                          <div className="flex-shrink-0 mt-1">
                            <Check className={`h-5 w-5 ${index % 2 === 0 ? 'text-book-yellow' : 'text-book-blue'}`} />
                          </div>
                          <p className="ml-3 text-gray-700">{topic}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AuthorSection;
